<template>
  <div class="modalFollow">
    <md-list class="md-triple-line">
      <div v-for="f in follow" :key="f.id">
        <md-list-item>
          <md-avatar>
            <img :src="f.profileImg" alt="People">
          </md-avatar>

          <div class="md-list-item-text">
            <span @click="linkToProfile(f.id)">{{ f.fullName }}</span>
          </div>

          <follow v-if="f.id != user.id && followingStatus && !disableFollowing" v-model="followingStatus[f.id]">
            <md-button
              slot-scope="{ loading, follow }"
              @click="follow(f.id)"
              class="md-icon-button md-list-action md-primary"
              :disabled="loading"
            >
              <md-icon>{{ !followingStatus[f.id] ? 'person_add' : 'person_add_disabled' }}</md-icon>
            </md-button>
          </follow>
        </md-list-item>

        <md-divider class="md-inset"></md-divider>
      </div>
    </md-list>
  </div>
</template>

<script>
import LogRocket from "logrocket";
import follow from "@/components/shared/friends/follow";
import call from "@/api/calls";

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  props: ["profiles", "disableFollowing"],
  components: {
    follow
  },
  data() {
    return {
      followStatic: [
        {
          id: "1234512345123450",
          fullName: "Pessoa Um",
          profileImg: "@/assets/avatarDefault.png",
        },
        {
          id: "1234512345123451",
          fullName: "Pessoa Dois",
          profileImg: "@/assets/avatarDefault.png",
        },
        {
          id: "1234512345123452",
          fullName: "Pessoa Tres",
          profileImg: "@/assets/avatarDefault.png",
        },
        {
          id: "1234512345123453",
          fullName: "Pessoa Quatro",
          profileImg: "@/assets/avatarDefault.png",
        },
        {
          id: "1234512345123454",
          fullName: "Pessoa Cinco",
          profileImg: "@/assets/avatarDefault.png",
        },
        {
          id: "1234512345123455",
          fullName: "Pessoa Seis",
          profileImg: "@/assets/avatarDefault.png",
        },
        {
          id: "1234512345123456",
          fullName: "Pessoa Sete",
          profileImg: "@/assets/avatarDefault.png",
        },
        {
          id: "1234512345123457",
          fullName: "Pessoa Oito",
          profileImg: "@/assets/avatarDefault.png",
        },
      ],
      follow: null,
      followingStatus: null
    }
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem('user'));
    }
  },
  watch: {
    '$route.params.id'() {
      this.follow = null;
    }
  },
  mounted() {
    this.loadProfiles();
  },
  methods: {
    linkToProfile(id) {
      this.$emit('clickLink');
      this.$router.push({ name: 'profile', params: { id }});
    },
    loadProfiles() {
      if (this.follow)
        return this.follow;

      return call.profile.getChaptersData(this.profiles.map(f => f.profile || f.follower))
      .then(profiles => this.follow = profiles)
      .then(profiles => this.loadFollowingStatus(profiles))
      .then(statuses => this.followingStatus = statuses)
      .catch(error => {
        log(error, "loadProfiles()", null);
      })
    },
    loadFollowingStatus(followers) {
      return call.friend.isFollowingBack(this.user.id, followers.map(f => f.id))
      .then(following => {
        let status = {};
        following.forEach(el => status[el.profile] = true);
        return status;
      })
    },
    isFollowing(id) {
      return this.followingStatus && this.followingStatus[id] || (this.followingStatus[id] = false);
    }
  },
}
</script>

<style scoped>

</style>
